export const classes = {
  content: 'text-[13px] text-taupe-2 mt-1 dark:text-mauve-2',
  bold: 'font-semibold text-taupe-3 dark:text-mauve-1',
};
